import { createInertiaApp } from '@inertiajs/react'
import { AppLayout } from '@/layouts/app-layout'
import './applications.css'
createInertiaApp({
  pages: "../pages",

  // Wraps every page in AppLayout by default — pages don't import the
  // header themselves. A page can override with `Page.layout = (page) =>
  // <OtherLayout>{page}</OtherLayout>` if it ever needs different chrome.
  layout: () => AppLayout,

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_javascript_tag "inertia.jsx" %> to the Inertia-specific layout instead.',
    )
  }
})
